<template>
  <div class="flashing-btn">
    <v-menu
      v-model="isShow"
      :offset-y="top || bottom"
      :offset-x="left || right"
      :content-class="`${contentClass} flashing-position`"
      :bottom="top"
      :top="bottom"
      :right="left"
      :left="right"
      :allow-overflow="true"
      :close-on-content-click="false"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          ref="btn"
          icon
          :class="{ [leftClass]: leftClass, 'approve-hotspot': rightClass }"
          v-on="on"
          @click="onClick"
        >
          <div class="flashing-btn__icon"></div>
          <span class="flashing-btn__ring"></span>
        </v-btn>
      </template>
      <HotSpot
        v-if="isShow"
        :title="title"
        :contents="contents"
        :top="top"
        :bottom="bottom"
        :left="left"
        :right="right"
        :hideBtn="true"
        :leftClass="leftClass"
        :rightClass="rightClass"
        :showFakeCard="showFakeCard"
        @close="onClose"
      />
    </v-menu>
  </div>
</template>
<script>
import HotSpot from './HotSpot';

export default {
  name: 'FlashingButton',
  components: {
    HotSpot,
  },

  props: {
    title: String,
    contents: {
      type: Array,
      default: () => [],
    },

    contentClass: String,
    top: Boolean,
    bottom: Boolean,
    left: Boolean,
    right: Boolean,
    showDefault: Boolean,
    leftClass: String,
    rightClass: String,
    showFakeCard: Boolean,
  },

  data() {
    return {
      isShow: false,
      show: true,
    };
  },

  watch: {
    isShow(v) {
      if (!v) {
        this.$emit('close');
      }
    },
  },

  mounted() {
    setTimeout(() => {
      if (this.showDefault) {
        this.isShow = this.showDefault;
        this.show = false;
      }
    }, 100);
  },

  methods: {
    onClose() {
      this.isShow = false;
    },

    onClick() {
      this.show = false;
      this.$emit('click');
    },
  },
};
</script>
<style scoped lang="scss">
.flashing-btn {
  &__icon {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 24px;
    height: 24px;
    margin: -12px auto auto -12px;
    border: 2px solid #4f46e5;
    border-radius: 50%;
    transform-origin: 50% 50%;
    transition: opacity 0.2s ease-in, transform 0.1s ease-out;
    color: white;
    font-size: 1.5em;
    padding: 0;
    text-align: center;
    line-height: 32px;
    overflow: hidden;
    z-index: 99;
    &::before {
      content: '';
      width: 16px;
      height: 16px;
      position: absolute;
      top: 50%;
      left: 50%;
      background-color: #4f46e5;
      border-radius: 100%;
      transform: translate(-50%, -50%);
    }
    &:hover {
      opacity: 0.8;
      cursor: pointer;
    }
    &:active {
      transform: scale(0.875);
    }
  }
  &__ring {
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 2em;
    height: 2em;
    margin: -1em auto auto -1em;
    transform-origin: 50% 50%;
    border-radius: 50%;
    border: 2px solid #4f46e5;
    opacity: 0;
    animation: pulsate 2s ease-out infinite;
  }

  &:hover .ring {
    animation: none;
  }

  &:active .ring {
    animation: stop-pulsate 0.5s;
  }
}
@keyframes pulsate {
  0% {
    transform: scale(0.5);
    opacity: 0.8;
  }
  45% {
    transform: scale(1.75);
    opacity: 0;
  }
}
@keyframes stop-pulsate {
  from {
    opacity: 0.4;
  }
  to {
    transform: scale(2);
    opacity: 0;
  }
}
.flashing-position {
  padding: 30px;
  box-shadow: none;
  z-index: 9999 !important;
  &::v-deep {
    .hot-spot__container {
      position: relative !important;
      transform: translate(-50%, 0px);
    }
  }
}
.tab-position {
  transform: translate(-50%, 0);
  margin-left: 22px;
}
.calibration-position {
  transform: translate(-50%, 0);
  margin-left: -20px;
  &::v-deep {
    .arrow-up {
      left: 60%;
    }
  }
}
.none-calibration-position {
  transform: translate(-25px, 0);
}
.rejected-position {
  transform: translate(-50%, 0);
  margin-left: 20px;
}
.right-position {
  transform: translate(0px, -50%);
  margin-top: 20px;
}

.email-top {
  z-index: 999 !important;
}
.team-position {
  transform: translate(-30px, -10px);
  &::v-deep .arrow-up {
    right: 85px;
    left: auto;
  }
}
.setting-position {
  transform: translate(0, -10px);
  right: 260px;
  left: auto !important;
  &::v-deep .arrow-up {
    right: 35px;
    left: auto;
  }
}
.left-position {
  transform: translate(0, -50%);
  margin-top: 20px;
}
.profile-position {
  transform: translate(0, 20px);
  right: 230px;
  left: auto !important;
  &::v-deep .arrow-up {
    right: 20px;
    left: auto;
  }
}
.info-position {
  transform: translate(10px, -20px);
  margin-top: 0px;
}
.opacity-0 {
  opacity: 0;
}
.history-top {
  transform: translate(0px, -75%);
  &::v-deep {
    .arrow-right {
      top: auto;
      bottom: 0px;
    }
  }
}
@media only screen and (max-width: 1670px) and (min-width: 1171px) {
  .rejected-position-left,
  .tab-position {
    left: 468px !important;
  }
}
@media only screen and (max-width: 1595px) {
  .rejected-position-right {
    left: auto !important;
    right: 140px;
  }
}
@media only screen and (max-width: 1170px) {
  .rejected-position-left,
  .tab-position {
    left: 200px !important;
  }
}
</style>
